<ng-container *ngIf="isMobile; else desktopSuggestions">
  <app-mobile-suggestions-list
    [suggestions]="suggestions"
    [suggestionsProducts]="suggestedProducts"
    [historyTerms]="historyTerms"
    [isSuggestionsListVisible]="isSuggestionsListVisible$ | async"
    [searchQuery]="searchQuery || ''"
    (promoClick)="onPromoLabelClick()"
    (termSelected)="onTermSelected($event)"
    (historyRemoved)="onHistoryRemoved($event)">
  </app-mobile-suggestions-list>
</ng-container>

<ng-template #desktopSuggestions>
  <app-desktop-suggestions-list
    [suggestions]="suggestions"
    [suggestionsProducts]="suggestedProducts"
    [historyTerms]="historyTerms"
    [isSuggestionsListVisible]="isSuggestionsListVisible$ | async"
    [searchQuery]="searchQuery || ''"
    (promoClick)="onPromoLabelClick()"
    (termSelected)="onTermSelected($event)"
    (historyRemoved)="onHistoryRemoved($event)"
    (productSelected)="onProductSelected($event.product, $event.priceType)">
  </app-desktop-suggestions-list>
</ng-template>
